import {StyleSheet} from "react-native";
import {Colors} from "./colors";

export const productItemImageWidth = 106;

export const ProductItemStyles = (colors: Colors) => {
    return StyleSheet.create({
        mainContainer: {
            flexDirection: "row",
            maxWidth: "100%",
            minHeight: productItemImageWidth,
            flex: 1,
            marginHorizontal: 16,
            marginVertical: 8
        },
        noProductItem: {
            borderRadius: 8,
            borderColor: colors.get("separator") as string,
            borderWidth: 0.5,
            justifyContent: "center",
            alignItems: "center",
            flex: 1,
            flexGrow: 1,
            maxWidth: "100%",
            height: productItemImageWidth,
        },
        detailsPartContainer: {
            borderColor: colors.get("separator") as string,
            flexGrow: 1,
            maxWidth: "100%",
            flex: 1,
            borderWidth: 0.5,
            borderBottomLeftRadius: 3,
            borderTopLeftRadius: 3,
            borderBottomRightRadius: 8,
            borderTopRightRadius: 8,
            height: "100%",
            padding: 6
        },
        detailsPartContainerNoImage: {
            borderBottomLeftRadius: 8,
            borderTopLeftRadius: 8
        },
        actionRowContainer: {
            flexDirection: "row",
            justifyContent: "center"
        },
        priceText: {
            flexGrow: 1,
            textAlign: "right"
        },
        deleteButton: {
            width: 26,
            height: 26,
            borderRadius: 14,
            backgroundColor: colors.get("red") as string,
            justifyContent: "center"
        },
        cartAddButton: {
            height: 27, backgroundColor: colors.get("green") as string,
            flexDirection: "row", alignItems: "center"
        },
        image: {
            width: productItemImageWidth,
            height: "100%",
            borderBottomLeftRadius: 8,
            borderTopLeftRadius: 8,
            borderBottomRightRadius: 3,
            borderTopRightRadius: 3,
        },
        productAdderContainer: {
            width: "100%",
            justifyContent: "flex-start",
            flexDirection: "column",
            overflow: "hidden",
            borderRadius: 8,
            shadowOpacity: .30,
            shadowRadius: 6,
            shadowOffset: {height: 8, width: 0},
            transform: [
                {translateY: -16}
            ],
        },
        productAdderInsideContainer: {
            width: "100%",
            borderTopWidth: 4,
            borderColor: colors.get("green") as string,
            paddingHorizontal: 12,
            paddingVertical: 8,
        },
        variantsContainer: {
            flex: 1, flexDirection: 'row', flexWrap: 'wrap', marginTop: 4
        },
        variantContainer: {
            marginTop: 6,
            width: "100%", borderRadius: 6, flexDirection: "row"
        },
        variantText: {
            paddingVertical: 4,
            flexGrow: 1, textAlign: "center"
        },
        selectivesAndAdditiveContainer: {
            flexWrap: "wrap", flexDirection: "row", marginTop: 4, columnGap: 6, rowGap: 6
        }
    })
}

export const MenuActionButtonStyles = (colors: Colors) => {
    return StyleSheet.create({
        buttonContainer: {
            bottom: 0,
            backgroundColor: "#0000",
            width: "100%",
            flexDirection: "row",
            position: "absolute",
            alignItems: "flex-end",
            paddingBottom: 14,
            paddingHorizontal: 7,
            flexBasis: 'auto',
            gap: 10,
            flex: 1
        },
        cartButtonContainer: {
            backgroundColor: colors.get("green") as string,
            borderRadius: 8,
            flexDirection: "row",
            paddingVertical: 6,
            paddingHorizontal: 12
        },
        profileButtonContainer: {
            borderRadius: 8,
            flexDirection: "column",
            paddingVertical: 6,
            paddingHorizontal: 12,
            justifyContent: "center",
            alignItems: "center"
        },
        servicesButtonContainer: {
            borderRadius: 8,
            flexDirection: "column",
            paddingVertical: 6,
            paddingHorizontal: 12,
            justifyContent: "center",
            alignItems: "center"
        },
        gameButtonContainer: {
            borderRadius: 8,
            flexDirection: "column",
            paddingVertical: 6,
            paddingHorizontal: 12,
            justifyContent: "center",
            alignItems: "center"
        },
    })
}